<template>
  <div v-if="page.about" :class="`page page-dark page-about page-about-${show ? 'show' : ''} page-about-${animation ? 'animation' : ''}`">
    <div class="about-main-text">
      <div class="container">
        <div class="col-md-12">
          <div v-html="page.about.text_lead_dark" class="lead lead-intro col-md-12"/>
          <h1>{{ page.about.name }}</h1>
        </div>
      </div>

      <div class="container">
        <div class="col-md-8">
          <div class="font-grotesque" v-html="page.about.text_principle_title_dark"/>
          <div class="text-blow-wrap">
            <div v-if="lang === 0" v-text-blow v-html="page.about.text_principle"/>
            <div v-if="lang === 0" class="text-blow-animation" v-text-blow v-html="page.about.text_principle"/>
            <div v-else v-html="page.about.text_principle_dark"/>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="col-md-8">
          <div class="font-grotesque" v-html="page.about.text_price_title_dark"/>
          <div class="text-blow-wrap">
            <div v-if="lang === 0" v-text-blow v-html="page.about.text_price"/>
            <div v-if="lang === 0" class="text-blow-animation" v-text-blow v-html="page.about.text_price"/>
            <div v-else v-html="page.about.text_price_dark"/>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="col-md-8">
          <div class="font-grotesque" v-html="page.about.text_geo_title_dark"/>
          <div class="text-blow-wrap">
            <div v-if="lang === 0" v-text-blow v-html="page.about.text_geo"/>
            <div v-if="lang === 0" class="text-blow-animation" v-text-blow v-html="page.about.text_geo"/>
            <div v-else v-html="page.about.text_geo_dark"/>
          </div>
        </div>
      </div>
    </div>
    <div class="about-map">
      <img src="/static/map_black.svg"/>
      <Cities :dark="true"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Cities from '@/components/Cities';

export default {
  name: 'about',
  components: {
    Cities,
  },
  watch: {
    theme() {
      this.checkAnimate();
    },
  },
  computed: mapGetters({
    firstVisitAnimation: 'firstVisitAnimation',
    theme: 'theme',
    page: 'page',
    lang: 'lang',
  }),
  data() {
    return {
      show: true,
      animation: false,
    };
  },
  mounted() {
    this.checkAnimate();
  },
  methods: {
    checkAnimate() {
      if (this.theme === 'dark') {
        this.show = true;
        setTimeout(() => {
          this.animate();
        }, 1400);
      }
    },
    animate() {
      this.animation = true;
      this.show = false;
      setTimeout(() => {
        this.animation = false;
      }, 2400);
    },
  },
};
</script>


<style>

@keyframes fall {
  from {
    transform: translate3d(0,0,0) rotateZ(0deg);
    opacity: 1;
  }
  to{
    transform: translate3d(-100px, 100vh, 0) rotateZ(20deg);
    opacity: 0;
  }
}

@keyframes blow-text{
  from,30%{
    opacity: 1;
  }
  50%{
    opacity: 0.15;
  }
}

.about{
  &-map{
    position: relative;
  }
}

.page-dark{
  .text-blow{
     &-animation{
      position: absolute;
      top: -15px;
      left: 0;

      .text-blow{
        opacity: 1;
        .text-blow-word{
          opacity: 0;
        }
      }

      p > span {
        opacity: 0;
      }
    }
  }
}

.page-about-animation{
  .text-blow{
     &-animation{
      .text-blow{
        .text-blow-word{
          transform-origin: center center;
          .in-viewport & {
            animation: fall 3.5s ease-in-out;
          }
        }
      }
    }
  }
}

.page-about-show{
  .text-blow{
     &-animation{
      .text-blow{
        .text-blow-word{
          opacity: 1;
        }
      }
    }
  }
}

.text-blow{
  &-wrap{
    position: relative;
    .text-blow{
      opacity: 0.15;
      
      span{
        display: inline-block;
      }
    }
  }

  &-word{
    white-space: nowrap;
  }

  p > span {
    span{
      display: inline-block;
    }
  }

}

.page-white .text-blow{
  &-wrap{
    position: relative;
    .text-blow{
      opacity: 1;     
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/pages/AboutUsDark.vue